import { useState, useEffect } from 'react';
import {
    ApolloClient,
    ApolloLink,
    InMemoryCache,
    HttpLink,
    DefaultOptions,
} from '@apollo/client';
import config from '../config';
import useToken from './token';

// Module-level variable to store the Apollo Client instance
let apolloClient: ApolloClient<any> | null = null;

const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
    mutate: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
};

const createApolloClient = (token: string | null) => {
    const httpLink = new HttpLink({
        uri: config.apiGateway.URL,
    });

    const authLink = new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                AccessKeyId: 'none',
                SecretKey: 'none',
                Authorization: token ? `Bearer ${token}` : '',
            },
        });
        return forward(operation);
    });

    return new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
        defaultOptions: defaultOptions,
    });
};

const useInitClient = (): ApolloClient<any> | null => {
    const token = useToken();
    const [client, setClient] = useState<ApolloClient<any> | null>(null);

    useEffect(() => {
        if (token && token !== 'expired') {
            apolloClient = createApolloClient(token);
            setClient(apolloClient);
        }
    }, [token]);

    return client;
};

const useClient = (): ApolloClient<any> => {
    if (!apolloClient) {
        throw new Error(
            'Apollo Client is not initialized because the token is not available yet.',
        );
    }

    return apolloClient;
};

export { useInitClient };
export default useClient;
